module.exports = __webpack_public_path__ + "img/W-S71.0b7a7105.jpg";